import axios from "axios";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ErrorModal from "./Alerts/ErrorModal";
import SuccessModal from "./Alerts/SuccessModal";
import "./App.scss";
import Router from "./routes/Router";
import { baseUrl, setIdToken } from "./utils/axiosInstance";
import { clearPersistedData } from "./utils/store/store";
import { deAuthenticateAll } from "./utils/store/reducers/Index";
import { refreshTokenAuth } from "./utils/store/reducers/authSlice";
import { setDefaultLoginId } from "./utils/store/reducers/accountSlice";
import { Toaster } from "react-hot-toast";
import RePaymentModal from "./reusableComponents/RePaymentModal/RePaymentModal";
import InfoModal from "./Alerts/InfoModal";
import ProjectXModal from "./reusableComponents/ProjectXModal/ProjectXModal";

function App() {
  const dispatch = useDispatch();
  const { login_id, data } = useSelector((state) => state?.accountList);
  const { refreshToken, rememberMe, idToken, userId } = useSelector(
    (state) => state.auth,
  );

  const af_device_id = localStorage.getItem("af-device-id");

  axios.defaults.baseURL = baseUrl;
  axios.defaults.headers.common["af-device-id"] = af_device_id;

  // Function to check if the token is expired
  const isTokenExpired = (accessToken) => {
    if (!accessToken || !accessToken?.expiryTimestamp) {
      return true;
    }

    const currentTime = Date.now();
    return currentTime >= accessToken.expiryTimestamp;
  };

  // useEffect(() => {
  //   const createdAt = Math.floor(Date.now() / 1000);
  //   let authUser = {

  //     app_id: 'xeh4v2mf',
  //     user_id: userId,
  //     name,
  //     email,
  //     created_at: createdAt,
  //   };

  //   let unAuthUser = {
  //     app_id: "xeh4v2mf",
  //   };
  //   // we have to change this condition as per need
  //   if (isAuthenticated) {
  //     Intercom(authUser);
  //   } else {
  //     Intercom(unAuthUser);
  //     Intercom("shutdown");
  //   }
  // }, [isAuthenticated]);

  useEffect(() => {
    if (userId) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "registration",
        authentication_method: "email",
        user_id: userId, // Replace with the actual user ID or email
      });
    }
  }, [userId]);

  // Set idToken in axiosInstance when idToken changes
  useEffect(() => {
    setIdToken(idToken);
  }, [idToken]);

  // Refresh token if expired every 45 minutes
  useEffect(() => {
    const interval = setInterval(
      () => {
        if (isTokenExpired(idToken)) {
          dispatch(refreshTokenAuth({ refresh_token: refreshToken }));
        }
      },
      1000 * 60 * 45,
    ); // 45 minutes

    return () => clearInterval(interval);
  }, [dispatch, refreshToken, idToken]);

  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        console.error("Axios response error:", error);

        const status = error?.response?.status;
        const originalRequest = error?.config || {};

        if (status === 403) {
          // For ANY 403 from any API, force logout/deauthentication
          deAuthenticateAll(dispatch);
          clearPersistedData();
          window.location.reload();
        } else if (status === 401) {
          // For 401, try refresh if rememberMe, otherwise logout
          if (!rememberMe) {
            deAuthenticateAll(dispatch);
            clearPersistedData();
            window.location.reload();
            return Promise.reject(error);
          }

          // Avoid infinite loop
          if (originalRequest._retry) {
            return Promise.reject(error);
          }
          originalRequest._retry = true;

          // Attempt refresh and then retry the original request with new token
          return dispatch(refreshTokenAuth({ refresh_token: refreshToken }))
            .unwrap()
            .then((payload) => {
              const newToken = payload?.idToken;
              if (newToken) {
                // Update default header and this request's header
                setIdToken(newToken);
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
              }
              return axios(originalRequest);
            })
            .catch(() => {
              deAuthenticateAll(dispatch);
              clearPersistedData();
              window.location.reload();
              return Promise.reject(error);
            });
        }

        return Promise.reject(error);
      },
    );

    // Eject the interceptor on component unmount
    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [dispatch, refreshToken, rememberMe]);

  useEffect(() => {
    if (
      (login_id === undefined || login_id === null) &&
      data?.results?.length > 0
    )
      dispatch(setDefaultLoginId(data?.results[0]?.login_id));
  }, [data?.results]);

  return (
    <div>
      <Router />
      <ErrorModal />
      <InfoModal />
      <SuccessModal />
      <Toaster position="top-right" reverseOrder={false} />
      <RePaymentModal />
      <ProjectXModal />
    </div>
  );
}

export default App;
